import { useQueryParam } from '@atlassian/react-resource-router';

/**
 * @function useOverrides
 * @returns a higher-order function that takes an `OverrideKey` and a boolean value,
 *   which returns either the value stored at the `OverrideKey` or, if there is none, the passed boolean.
 *
 * This is used in QA/development/testing to bypass certain eligibility checks.
 */
export const useOverrides = <OverrideKey extends string>(queryKey: string) => {
	const [value] = useQueryParam(queryKey);
	let overrides = {};
	if (value) {
		overrides = JSON.parse(value);
	}

	return createWithOverrides<OverrideKey>(overrides);
};

export function createWithOverrides<OverrideKey extends PropertyKey>(
	overrides: Partial<Record<OverrideKey, boolean>>,
) {
	return (key: OverrideKey, val: boolean): boolean => {
		if (Object.prototype.hasOwnProperty.call(overrides, key)) {
			const overrideVal = overrides[key];
			if (typeof overrideVal === 'boolean') {
				return overrideVal;
			}
		}
		return val;
	};
}
